module.exports = {
  headline: 'Inte tillgänglig för tillfället',
  text: 'Denna sida har medvetet utelämnats.',
};


// WEBPACK FOOTER //
// ./pages/content/comingSoon_SV.js